<template>
  <v-chip v-if="item.iraEligible" x-small>
    <v-icon left x-small> mdi-check-bold</v-icon>
    IRA
  </v-chip>
</template>

<script>
export default {
  props: ['item'],
}
</script>
